export const MAIN_CONTENT_MARGIN_TOP_WITHOUT_BREADCRUMBS = '58px' as const
